export default __webpack_public_path__ + "images/0x940181a94a35a4569e4529a3cdfb74e38fd98631.png";